import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { ToastrService } from 'ngx-toastr';
import { ForgotPassword } from 'src/app/model/ForgotPassword';
import { resource } from 'selenium-webdriver/http';

@Component({
  selector: 'app-forgotpwd',
  templateUrl: './forgotpwd.component.html',
  styleUrls: ['./forgotpwd.component.css']
})
export class ForgotpwdComponent implements OnInit 
{
  isLoading:boolean;
UserName:string;
  constructor(private accountService : AccountService, private toastrService:ToastrService,) { }

  ngOnInit() {
  }



async  submit()
  {
   this.isLoading=true;

    if(!this.UserName)
    {this.toastrService.warning("User name is required");
    this.isLoading=false;
      return;
    }
    let forgotPassword: ForgotPassword = {} as ForgotPassword;

    forgotPassword.UserName = this.UserName;
    var  FindUserNameresult =   await this.accountService.FindUserName(forgotPassword).toPromise();
   
 

  if(!FindUserNameresult || FindUserNameresult.Status==0 )
  {
    this.toastrService.error("Invalid username");
    this.isLoading=false;
    return;

  }
  var userid :string =FindUserNameresult.Result.UserID;
       if(FindUserNameresult.Status==1)    
      {       
      
    var  result =   await this.accountService.ResetPassword( userid).toPromise();

  
      if (result.Status==1)
      {  
        this.toastrService.info("Mail sent to your email succesfully");
        this.UserName="";
        this.isLoading=false;
      }
      else
      {
        this.toastrService.error("Password reset not succesful");
        this.isLoading=false;
      }
    }    
    else{   
   
      this.toastrService.error("Invalid username");
      this.isLoading=false;
     
    } 


    this.isLoading=false;
     

    


  }
}
